import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import getConfig from '../../../util/config';

const withGoogleRecaptchaProvider = WrappedComponent => props => {
  const { google } = getConfig();
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={google.recaptchaSiteKey}
      useEnterprise
    >
      <WrappedComponent {...props} />
    </GoogleReCaptchaProvider>
  );
};

export default withGoogleRecaptchaProvider;
